import { Button, CardContainer, Input, RichText } from '../../../components'
import { PRODUCTCATEGORY } from '../../../routes/routesNames';
import UseFormCategories from '../hookForm';

const EditProductCategory = () => {
    const {
        isReady,
        isLoadingPutDataForm,
        form,
        isEnable,
        navigate,
        content,
        handleChange,
        handleChangeRich,
        handleSubmit        
    } = UseFormCategories({
        type : 'put',
        redirect : PRODUCTCATEGORY,
        categoryType : 'product'
    })

  return (
      <CardContainer>
        <form onSubmit={e => isEnable ? handleSubmit(e) : e.preventDefault()}>
            <div className="col-lg-10 col-12">
                <div className="col-lg-8 col-12">
                    <Input
                        value={form.image_url}
                        type="file"
                        id="image"
                        onChange={handleChange}
                        placeholder="Format foto/gambar .JPG, .JPEG, .PNG, maksimal 2MB, dengan aspect ratio 1 : 1." 
                        label="Unggah Gambar" />
                    <Input
                        value={form.name}
                        id="name"
                        onChange={handleChange}
                        placeholder="Masukan nama kategori" 
                        label="Nama Kategori" />
                </div>
                {
                    isReady ?
                    <RichText value={content} onChange={handleChangeRich} label="Deskripsi" id="desc" /> : null
                }
                <div className="d-flex justify-content-end">
                    <div className="me-4">
                        <Button 
                            onClick={() => navigate(-1)}
                            type="button"
                            className={`btn-light w-100 mt-4 px-5`} 
                            title="Batalkan" />
                    </div>
                    <Button 
                        disabled={!isEnable}
                        type="submit"
                        className={`${isEnable  ? 'btn-primary' : 'btn-secondary'}  w-100 mt-4 px-5`} 
                        title="Ubah" 
                        isLoading={isLoadingPutDataForm} />
                </div>
            </div>
        </form>
      </CardContainer>
  )
}

export default EditProductCategory